import { Outlet } from 'react-router-dom';

const EntryLayout = () => {
  return (
    <div className="from-base-500 dark:from-content-800 via-base-100 dark:via-content-700 to-base-500 dark:to-content-800 relative grid h-full min-h-screen bg-gradient-to-tr px-4 py-2 xl:px-0 xl:pb-16 xl:pt-4">
      <div className="2xl:max-w-8xl relative z-50 mx-auto w-full max-w-6xl">
        <Outlet />
      </div>
    </div>
  );
};

export default EntryLayout;
